var v1="<div class=\"lbaLoader\" ng-if=\"vm.showLoader\"> <div class=\"lbaLoader_content\"> <div class=\"lbaLoader_message\"> <i ng-if=\"vm.state.showSpinner\" class=\"fa fa-circle-o-notch lbaLoader_spinner\"></i> <div> <i ng-if=\"vm.state.icon\" class=\"fa {{vm.state.icon}} lbaLoader_icon\"></i>\n<span ng-bind-html=\"vm.state.message\"></span> </div> </div> <button class=\"lbaLoader_continue btn\" ng-if=\"vm.state.showContinue\" ng-click=\"vm.continue()\">Continue</button>\n<button class=\"lbaLoader_continue btn\" ng-if=\"vm.state.showRefresh\" ng-click=\"vm.refresh()\">Refresh page</button> </div> </div>";
window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("components/lbaLoader/lbaLoader.html", v1)}]);
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./src/components/lbaLoader/lbaLoader.html
// module id = 234
// module chunks = 0